<template>
  <v-text-field
    v-if="showItem"
    :label="item.label"
    v-model="item.value"
    :rules="rulesValidation"
    :maxlength="item.maxlength ? item.maxlength: 1000"
    :disabled="disabled || item.readonly"
    :persistent-hint="!localItem"
    hint="E' possibile creare automaticamente un barcode"
    :error="barcodeError"
    :error-messages="barcodeError ? errorMessage : ''"
    :loading="verificaInCorso"
    @change=onChange>
    <template v-slot:append-outer>
      <v-icon color="success" @click="generaBarcode" title="Genera un nuovo barcode">mdi-barcode</v-icon>
    </template>
  </v-text-field>
</template>

<script>
  import prodotti from '@/services/prodottiService.js'
  import { validazioni } from '@/mixins/validazioni.js'

  export default {
    name: 'barcode',
    mixins: [
      validazioni
    ],
    props: {
      item: Object,
      appoggio: Object,      
      disabled: { type: Boolean, default: false }
    },
    data: (vm) => ({
      localItem: vm && vm.item ? vm.item.value : '',
      barcodeError: false,
      verificaInCorso: false,
      errorMessage: '',
      originalValue: vm && vm.item && vm.item.value ? JSON.parse(JSON.stringify(vm.item.value)) : ''
/*       rules: {
        required: value => !!value || 'Campo richiesto.',
        counter: value => value.length <= vm.item.maxlength || `Max ${vm.item.maxlength} caratteri`
      } */
    }),
    mounted() {
      this.originalValue = this.item && this.item.value ? JSON.parse(JSON.stringify(this.item.value)) : ''
    },
    watch: {
      showDrawer(value) {
        if (value && this.item && this.item.value) {
          this.originalValue = JSON.parse(JSON.stringify(this.item.value))
        }
      }
    },
    computed: {
      showDrawer() {
        return this.$store.getters.rightDrawer
      },
      showItem() {
        if (this.item && this.item.showIf) {
          return _.get(this, this.item.showIf, false)
        } else if (this.item && this.item.hideIf) {
          return !_.get(this, this.item.hideIf, false)
        } else {
          return true
        }
      }
    },
    methods: {
      async generaBarcode() {
        var newcode
        if (this.appoggio.pesoVariabile) {
          newcode = await prodotti.generaBarcodeProdottoPV()
        } else {
          newcode = await prodotti.generaBarcodeProdotto()
        }
        this.originalValue = newcode
        this.onChange(newcode)
      },
      async onChange(value) {
        if (value) {
          this.barcodeError = false
          this.verificaInCorso = true
          const result = await prodotti.verificaBarcodeValido(value)
          this.verificaInCorso = false
          if (result.status === 'ok' || (result.status === 'error' && this.originalValue === value)) {
            this.barcodeError = false
            this.item.value = value
            this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value })
          } else {
            this.barcodeError = true
            this. errorMessage = result.error
          }
        }
      }
    }
  }
</script>